import { application } from "../application"

import RadioButtonController from "./radio_button_controller"
application.register("radio-button", RadioButtonController);

import FaqsController from "./faqs_controller"
application.register("faqs", FaqsController);

import QuestionFormController from "./question_form_controller";
application.register("question-form", QuestionFormController);

import CalculatorConsentController from "./calculator_consent_controller";
application.register("calculator-consent", CalculatorConsentController);

import ConsultFormController from "./consult_form_controller";
application.register("consult-form", ConsultFormController);

import CarouselController from "./carousel_controller";
application.register("carousel", CarouselController);

import PflegebudgetRechnerController from "./pflegebudget_rechner_controller";
application.register("pflegebudget-rechner", PflegebudgetRechnerController);

import PflegekostenVergleichController from "./pflegekosten_vergleich_controller";
application.register("pflegekosten-vergleich", PflegekostenVergleichController);

import TableSortController from "./table_sort_controller";
application.register("table-sort", TableSortController);

import PflegeRenteRechnerController from "./pflege_rente_rechner_controller";
application.register("pflege-rente-rechner", PflegeRenteRechnerController);
import ElternunterhaltRechnerController from "./elternunterhalt_rechner_controller";
application.register("elternunterhalt-rechner", ElternunterhaltRechnerController);
import PflegereformRechnerController from "./pflegereform_rechner_controller";
application.register("pflegereform-rechner", PflegereformRechnerController);

import ZuschussRechnerController from "./zuschuss_rechner_controller";
application.register("zuschuss-rechner", ZuschussRechnerController);

import IntensivpflegeCheckController from "./intensivpflege_check_controller";
application.register("intensivpflege-check", IntensivpflegeCheckController);

import ElektrorollstuhlCheckController from "./elektrorollstuhl_check_controller";
application.register("elektrorollstuhl-check", ElektrorollstuhlCheckController);

import FunnelStickyBarController from "./funnel_sticky_bar_controller";
application.register("funnel-sticky-bar", FunnelStickyBarController);

import CollapsibleController from "./collapsible_controller";
application.register("collapsible", CollapsibleController);

import StickyCTAController from "./sticky_cta_controller";
application.register("sticky-cta", StickyCTAController);

import DesktopPopupCTAController from "./desktop_popup_cta_controller";
application.register("desktop-popup-cta", DesktopPopupCTAController);

import LeadMagnetFormController from "../pages_controllers/lead_magnet_form_controller";
application.register("lead-magnet-form", LeadMagnetFormController);

import SelbsttestController from "./selbsttest_controller";
application.register("selbsttest", SelbsttestController);

import PillarNavController from "./pillar_nav_controller";
application.register("pillar-nav", PillarNavController);

import PrintController from "../shared_controllers/print_controller";
application.register("print", PrintController);

import InfoHintController from "./info_hint_controller";
application.register("info-hint", InfoHintController);
